function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSectionView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.17 38.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("line", {
    x1: 2.46,
    y1: 4.05,
    x2: 24.67,
    y2: 4.05,
    style: {
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "1.32 4.09 7.06 2.5 7.06 5.61 1.32 4.1",
    style: {
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0393753050145649px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.53,
    y1: 34.18,
    x2: 23.74,
    y2: 34.18,
    style: {
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.24,35.13l5.38-1.51v3.1L2.24,35.13",
    transform: "translate(-0.92 -0.96)",
    style: {
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8799514174461365px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.51,
    y1: 0.5,
    x2: 0.51,
    y2: 8.26,
    style: {
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.51,
    y1: 10.25,
    x2: 0.51,
    y2: 13.59,
    style: {
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 15.58,
    x2: 0.5,
    y2: 23.34,
    style: {
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 25.34,
    x2: 0.5,
    y2: 28.67,
    style: {
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 30.67,
    x2: 0.5,
    y2: 38.43,
    style: {
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionView);
export default __webpack_public_path__ + "static/media/section-view.631ce891de97994c7e9d9803df06a27d.svg";
export { ForwardRef as ReactComponent };